<template>
    <v-dialog max-width="70%" v-model="dialog">
        <v-card min-width="70%">
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1 mr-n2" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="py-0">
                <v-text-field type="number" v-model="min[0]" outlined dense :rules="[rules.value]" @input="onInput(0)"></v-text-field>
                <v-card class="ma-1" elevation="0">.</v-card>
                <v-text-field type="number" v-model="min[1]" outlined dense :rules="[rules.value]" @input="onInput(0)"></v-text-field>
                <v-card class="ma-1" elevation="0">.</v-card>
                <v-text-field type="number" v-model="min[2]" outlined dense :rules="[rules.value]" @input="onInput(0)"></v-text-field>
                <v-card class="ma-3 pb-6" elevation="0">-</v-card>
                <v-text-field type="number" v-model="max[0]" outlined dense :rules="[rules.value]" @input="onInput(1)"></v-text-field>
                <v-card class="ma-1" elevation="0">.</v-card>
                <v-text-field type="number" v-model="max[1]" outlined dense :rules="[rules.value]" @input="onInput(1)"></v-text-field>
                <v-card class="ma-1" elevation="0">.</v-card>
                <v-text-field type="number" v-model="max[2]" outlined dense :rules="[rules.value]" @input="onInput(1)"></v-text-field>
            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn  class="ma-2"
                        color="primary"
                        @click="onPressUpdate">UPDATE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: "popup-edit-version",
    props: {},
    data: () => ({
        dialog: false,
        min: ['0','0','0'],
        max: ['0','0','0'],
        onComplete:null,
        rules: {
            value: value => Number(value) >= 0 || '> 0',
        },
    }),
    computed: {},
    methods: {
        onInput(tag){
            /*var self = this;
            setTimeout(function() {
                if (tag == 0){
                    self.max[0] = self.min[0]
                    self.max[1] = self.min[1]
                }else{
                    self.min[0] = self.max[0]
                    self.min[1] = self.max[1]
                }
                //console.log("onInput: ", tag, self.min.join("."), self.max.join("."))
                self.$forceUpdate();
            }, 50)*/
        },
        show(minver, maxver, onComplete) {
            this.onComplete = onComplete
            if (minver){ this.min = minver?.split(".") }
            if (maxver){ this.max = maxver?.split(".") }
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.hide()
        },
        onPressUpdate() {
            for (let a in this.min){
                if (Number(this.min[a]) < 0){
                    this.$notify({title: 'min contain elements < 0', type: "error"});
                    return;
                }
            }

            for (let a in this.max){
                if (Number(this.max[a]) < 0){
                    this.$notify({title: 'max contain elements < 0', type: "error"});
                    return;
                }
            }

            let min = this.min.join(".")
            let max = this.max.join(".")

            if (this.isNewerVersion(min, max) == false){
                let error = min + ">=" + max
                this.$notify({title: 'min >= max', text:error, type: "error"});
                return;
            }

            this.onComplete(min, max);
        },
        isNewerVersion (oldVer, newVer) {
            const oldParts = oldVer.split('.')
            const newParts = newVer.split('.')
            for (var i = 0; i < newParts.length; i++) {
                const a = ~~newParts[i] // parse int
                const b = ~~oldParts[i] // parse int
                if (a > b) return true
                if (a < b) return false
            }
            return false
        },
    },
}
</script>

<style scoped>
</style>